// Libs
import React from 'react'

// Constants
import { SUPPORT_PHONE_NUMBER } from 'hfty'

// Styles
import { primary, lightFEBlue } from 'hfty-styles/src/colors'

const styles = {
  warningContainer: {
    padding: '16px',
    borderRadius: '0.75rem',
    backgroundColor: lightFEBlue,
    color: primary(),
  },
  link: {
    color: primary(),
  },
}

export const PaymentWarning = () => {
  return (
    <p style={styles.warningContainer}>
      We are currently upgrading our payment platform. To continue with your order, please contact our support at{' '}
      <a href={`tel:${SUPPORT_PHONE_NUMBER}`} style={styles.link}>
        {SUPPORT_PHONE_NUMBER}
      </a>
    </p>
  )
}

export default PaymentWarning
